import React, { useContext } from 'react';

import { Sparkles, Zap } from 'lucide-react';

import { RouterContext } from 'common/containers/RouterContainer';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';

import type { Company } from 'common/api/endpoints/companies';

import 'css/components/subdomain/admin/_AdminQueueAutomationUpsell.scss';

type Props = {
  company: Company;
};

const AdminQueueAutomationUpsell = ({ company }: Props) => {
  const router = useContext(RouterContext);

  if (company.queueAutomation?.enabled) {
    return null;
  }

  return (
    <>
      <div className="adminQueueAutomationUpsell">
        <div className="left">
          <div className="badgeContainer">
            <Zap height={16} width={16} className="badgeIcon" />
          </div>
          <P>
            Save time by automatically accepting suggestions. You can monitor and revert actions if
            needed.
          </P>
        </div>
        <ButtonV2
          onClick={() => router.push('/admin/settings/autopilot/feedback-discovery')}
          size="medium"
          startIcon={Sparkles}>
          Automate actions
        </ButtonV2>
      </div>
    </>
  );
};

export default AdminQueueAutomationUpsell;
